"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneSDKMetricId = exports.ZoneWebMetricId = exports.ZoneMetricCategory = void 0;
/**@deprecated */
var ZoneMetricCategory;
(function (ZoneMetricCategory) {
    ZoneMetricCategory["Attractiveness"] = "attractiveness";
    ZoneMetricCategory["ROI"] = "roi";
    ZoneMetricCategory["Performance"] = "performance";
    ZoneMetricCategory["Interaction"] = "interaction";
    ZoneMetricCategory["Heatmap"] = "heatmap";
})(ZoneMetricCategory = exports.ZoneMetricCategory || (exports.ZoneMetricCategory = {}));
var ZoneWebMetricId;
(function (ZoneWebMetricId) {
    ZoneWebMetricId["AttractivenessRate"] = "attractivityRate";
    ZoneWebMetricId["AverageRevenueAfterClick"] = "averageRevenueAfterClick";
    ZoneWebMetricId["ClickRate"] = "clickRate";
    ZoneWebMetricId["ClickRepetition"] = "clickRepetition";
    ZoneWebMetricId["DragRateWeb"] = "dragRateWeb";
    ZoneWebMetricId["AvgConversionAfterClick"] = "avgConversionAfterClick";
    ZoneWebMetricId["AvgTransactionAfterClick"] = "avgTransactionAfterClick";
    ZoneWebMetricId["AvgConversionAfterHover"] = "avgConversionAfterHover";
    ZoneWebMetricId["AvgTransactionAfterHover"] = "avgTransactionAfterHover";
    ZoneWebMetricId["AvgExposureTime"] = "avgExposureTime";
    ZoneWebMetricId["AvgHoverTime"] = "avgHoverTime";
    ZoneWebMetricId["ExposureRate"] = "exposureRate";
    ZoneWebMetricId["EngagementRateLive"] = "engagementRateLive";
    ZoneWebMetricId["FlickRateWeb"] = "flickRateWeb";
    ZoneWebMetricId["Hesitation"] = "hesitation";
    ZoneWebMetricId["HoverRate"] = "hoverRate";
    ZoneWebMetricId["ClickRateSession"] = "clickRateSession";
    ZoneWebMetricId["SwipeRateWeb"] = "dragFlickRateWeb";
    ZoneWebMetricId["TimeBeforeFirstClick"] = "timeBeforeFirstClick";
    ZoneWebMetricId["TotalClicks"] = "totalClicks";
    ZoneWebMetricId["TotalRevenueAfterClick"] = "totalRevenueAfterClick";
})(ZoneWebMetricId = exports.ZoneWebMetricId || (exports.ZoneWebMetricId = {}));
var ZoneSDKMetricId;
(function (ZoneSDKMetricId) {
    ZoneSDKMetricId["AverageRevenueAfterTap"] = "averageRevenueAfterTap";
    ZoneSDKMetricId["AvgConversionAfterTap"] = "avgConversionAfterTap";
    ZoneSDKMetricId["AvgTransactionAfterTap"] = "avgTransactionAfterTap";
    ZoneSDKMetricId["DragFlickRate"] = "dragFlickRate";
    ZoneSDKMetricId["FlickRate"] = "flickRate";
    ZoneSDKMetricId["DragRate"] = "dragRate";
    ZoneSDKMetricId["DragFlickRecurrence"] = "dragFlickRecurrence";
    ZoneSDKMetricId["FlickRecurrence"] = "flickRecurrence";
    ZoneSDKMetricId["DragRecurrence"] = "dragRecurrence";
    ZoneSDKMetricId["TapRate"] = "tapRate";
    ZoneSDKMetricId["TapRateSession"] = "tapRateSession";
    ZoneSDKMetricId["TapRecurrence"] = "tapRecurrence";
    ZoneSDKMetricId["TimeBeforeFirstTap"] = "timeBeforeFirstTap";
    ZoneSDKMetricId["TotalRevenueWithTap"] = "totalRevenueWithTap";
    ZoneSDKMetricId["TapCount"] = "tapCount";
})(ZoneSDKMetricId = exports.ZoneSDKMetricId || (exports.ZoneSDKMetricId = {}));
//# sourceMappingURL=zone-metric.js.map